<template>
  <div class="question_item">
    <div class="question_item_title">
      <div class="question_q_img">
        <img src="../assets/web/Question.png" />
        <span>Q{{index + 1}}</span>
      </div>
      <div class="row-align-center question_item_title_text">
        <div
          v-if="question && question.question"
          class="row-align-center"
          style="flex:1;flex-wrap:wrap;"
        >
          <div class="html-box" v-html="question.question.localeText"></div>
          <span>-{{question.question.questionType == 'TRUE_OR_FALSE' ? $t('message.title_TRUE_OR_FALSE'):question.question.questionType == 'SINGLE_CHOICE' ? $t('message.title_SINGLE_CHOICE'): question.question.questionType == 'SHORT_ANSWER' ? $t('message.title_SHORT_ANSWER') : question.question.questionType == 'MULTIPLE_CHOICE' ? $t('message.title_MULTIPLE_CHOICE'):''}}</span>
        </div>
        <img
          src="../assets/web/AuditionGreen.png"
          alt
          class="audio_icon"
          @click="audioPlayer('question')"
        />
      </div>
    </div>
    <div class="question_item_answer">
      <el-row>
        <el-col
          :xs="24"
          :sm="24"
          :md="isResult ? 16:24"
          :lg="isResult ? 16:24"
          :xl="isResult ? 16:24"
        >
          <!-- 多選題 -->
          <div v-if="questionType && questionType == 'MULTIPLE_CHOICE'">
            <el-checkbox-group v-model="question.answer">
              <el-checkbox
                :label="choice"
                v-for="(choice,choiceIndex) in question.question.randomChoices"
                :key="choiceIndex"
                :disabled="showResult"
                class="answer_radios_items"
              >
                <div v-if="!!choice">
                  <img
                    v-if="showMultiplCorrect(choiceIndex)"
                    src="../assets/web/Correct.png"
                    alt
                    class="result_icon"
                  />
                  <img
                    v-if="showResult && !showMultiplCorrect(choiceIndex)"
                    src="../assets/web/Wrong.png"
                    alt
                    class="result_icon"
                  />
                </div>
                <span>{{choiceIndex | abcd}}. {{choice}}</span>
                <img
                  src="../assets/web/AuditionGreen.png"
                  alt
                  class="audio_icon"
                  @click="audioPlayer('answer',choiceIndex)"
                />
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <!-- 單選題 -->
          <div v-if="questionType && questionType == 'SINGLE_CHOICE'" class="answer_radios">
            <div
              class="answer_radios_items"
              v-for="(choice,choiceIndex) in question.question.randomChoices"
              :key="choiceIndex"
            >
              <div v-if="!!choice">
                <img
                  v-if="showResult && !answerDetail.correct && choice == question.answer"
                  src="../assets/web/Wrong.png"
                  alt
                  class="result_icon"
                />
                <img
                  v-if="showResult && question.question.randomAnswer == choiceIndex"
                  src="../assets/web/Correct.png"
                  alt
                  class="result_icon"
                />
              </div>
              <el-radio v-model="question.answer" :label="choice" :disabled="showResult">
                <span>{{choiceIndex | abcd}}. {{choice}}</span>
                <img
                  src="../assets/web/AuditionGreen.png"
                  alt
                  class="audio_icon"
                  @click="audioPlayer('answer',choiceIndex)"
                />
              </el-radio>
            </div>
          </div>
          <!-- 是非題 -->
          <div v-if="questionType && questionType == 'TRUE_OR_FALSE'" class="answer_radios">
            <div class="answer_radios_items">
              <img
                v-if="showResult && !answerDetail.correct && !answerDetail.question.answer"
                src="../assets/web/Wrong.png"
                alt
                class="result_icon"
              />
              <img
                v-if="showResult && answerDetail.question.answer"
                src="../assets/web/Correct.png"
                alt
                class="result_icon"
              />
              <el-radio v-model="question.answer" :label="true" :disabled="showResult">
                <span>{{0 | abcd}}. {{$t('message.correct')}}</span>
                <img
                  src="../assets/web/AuditionGreen.png"
                  alt
                  class="audio_icon"
                  @click="audioPlayer('TRUE_OR_FALSE',0)"
                />
              </el-radio>
            </div>
            <div class="answer_radios_items">
              <img
                v-if="showResult && !answerDetail.correct && answerDetail.question.answer"
                src="../assets/web/Wrong.png"
                alt
                class="result_icon"
              />
              <img
                v-if="showResult && !answerDetail.question.answer"
                src="../assets/web/Correct.png"
                alt
                class="result_icon"
              />
              <el-radio v-model="question.answer" :label="false" :disabled="showResult">
                <span>{{1 | abcd}}. {{$t('message.wrong')}}</span>
                <img
                  src="../assets/web/AuditionGreen.png"
                  alt
                  class="audio_icon"
                  @click="audioPlayer('TRUE_OR_FALSE',1)"
                />
              </el-radio>
            </div>
          </div>
          <!-- 簡答題 -->
          <div v-if="questionType && questionType == 'SHORT_ANSWER'" style="width:90%;">
            <el-input type="textarea" :rows="4" v-model="question.answer" :disabled="showResult"></el-input>
          </div>
        </el-col>
        <!-- 结果 -->
        <el-col
          v-if="!$store.state.isMobile && showResult"
          :xs="24"
          :sm="24"
          :md="8"
          :lg="8"
          :xl="8"
        >
          <div v-if="showResult" class="correct">
            <div
              v-if="!answerDetail.correct && answerDetail.question.questionType != 'TRUE_OR_FALSE'"
              :class="answerDetail.question.questionType == 'SHORT_ANSWER' ? 'correct_short_answer' : 'correct_answer'"
            >{{answerDetail.question.answerAlias || answerDetail.question.answer || answerDetail.question[`answer${$t('message.lan')}`] | sortLetter}}</div>
            <div
              v-if="!answerDetail.correct && answerDetail.question.questionType == 'TRUE_OR_FALSE'"
              class="correct_answer"
            >
              <img src="../assets/web/Wrong.png" alt />
            </div>
            <div v-if="answerDetail.correct" class="correct_answer">
              <img src="../assets/web/Correct.png" alt />
            </div>
            <div
              class="correct_text"
            >{{answerDetail.correct ? $t('message.correct_answer'):answerDetail.question.questionType == 'TRUE_OR_FALSE'?$t('message.wrong_answer'):$t('message.right_key')}}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 播放聲音 -->
    <div class="courserView_audio">
      <audio ref="myAudio" :src="audioUrl" controls style="display:none;" autoplay></audio>
    </div>
  </div>
</template>

<script>
import AudioCheckAPI from "../api/AudioCheckAPI"
import { basePathUrl } from "../api/axios";
export default {
  props: {
    question: {},
    showResult: {
      type: Boolean,
      default: false
    },
    isResult: {
      type: Boolean,
      default: false
    },
    answerDetail: {},
    index: Number
  },
  data() {
    return {
      basePathUrl: basePathUrl,
      audioUrl: null,
      soundLocale: "ZH_TW"
    };
  },
  computed: {
    questionType() {
      const question = this.question;
      return question && question.question && question.question.questionType;
    },
    showMultiplCorrect() {
      return function(index) {
        return this.showResult &&
          this.answerDetail.question.randomAnswer.includes(index)
          ? true
          : false;
      };
    }
  },
  methods: {
    // 播放語音
    audioPlayer(type, index) {
      console.log('index:',index);
      // console.log(type);
      const isApple = this.$store.state.isApple ? "/iOS" : "";
      const message = () => {
        this.$message({
          type: "warning",
          message: this.$t('message.noVoice')
        });
      }
      if (type == "question") {
        // const questionId = this.question.question.id;
        // if(this.soundLocale == 'ZH_TW' || this.soundLocale == "ZH_CN"){
          this.audioUrl = `${this.basePathUrl}question/audios/${this.question.question.id}${isApple}?lang=${this.soundLocale}`;
        // }else {
        //   AudioCheckAPI.checkQuetionAudio(questionId, this.soundLocale)
        //     .then(res => {
        //       if(res){
        //         this.audioUrl = `${this.basePathUrl}question/audios/${questionId}${isApple}?lang=${this.soundLocale}`;
        //       }else {
        //         message();
        //       }
        //     })
        //     .catch(err => this.$error(err));
        // }
      } else if (type == "answer") {
        const questionId = this.question.question.id;
        const choiceIndex = this.question.question.normalIndexOfRandomChoice[index];
        // if(this.soundLocale == 'ZH_TW' || this.soundLocale == "ZH_CN"){
          this.audioUrl = `${this.basePathUrl}question/audios/${questionId}/choice/${choiceIndex}${isApple}?lang=${this.soundLocale}`;
        // }else{
        //   AudioCheckAPI.checkQuetionChoiceAudio(questionId, choiceIndex, this.soundLocale)
        //     .then(res => {
        //       if(res){
        //         this.audioUrl = `${this.basePathUrl}question/audios/${questionId}/choice/${choiceIndex}${isApple}?lang=${this.soundLocale}`;
        //       }else{
        //         message();
        //       }
        //     })
        // }
      } else if (type == "TRUE_OR_FALSE") {
        const questionId = this.question.question.id;
        // if(this.soundLocale == 'ZH_TW' || this.soundLocale == "ZH_CN"){
          this.audioUrl = `${this.basePathUrl}question/audios/${questionId}/choice/${index}${isApple}?lang=${this.soundLocale}`;
        // }else{
        //   AudioCheckAPI.checkQuetionChoiceAudio(questionId, index, this.soundLocale)
        //     .then(res => {
        //       if(res){
        //         this.audioUrl = `${this.basePathUrl}question/audios/${questionId}/choice/${index}${isApple}?lang=${this.soundLocale}`;
        //       }else{
        //         message();
        //       }
        //     })
        // }
      }
      setTimeout(() => {
        this.$refs.myAudio.play();
      }, 300);
    }
  },
  created() {
    const sound = localStorage.getItem("sound") || 'TW';
    if(sound == 'CN'){
      this.soundLocale = "ZH_CN";
    }else if(sound == 'E'){
      this.soundLocale = "EN";
    }else if(sound == 'P'){
      this.soundLocale = "PT";
    }else{
      this.soundLocale = "ZH_TW";
    }
  }
};
</script>

<style lang="scss" scoped>
.question_item {
  // margin-bottom: 24px;
  .question_item_answer {
    .el-checkbox-group {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-left: 16px;
      .el-checkbox {
        padding: 15px 0;
      }
      /deep/.el-checkbox__label {
        // font-size: 20px;
        font-weight: 400;
        white-space: normal;
      }
    }
    .el-radio is-checked {
    }
    .el-textarea {
      padding: 20px 0;
    }
    .answer_radios {
      display: flex;
      flex-direction: column;
      margin-left: 16px;
      // /deep/.el-radio {
      //   padding: 15px 0;
      //   .el-radio__label {
      //     font-size: 20px !important;
      //     font-weight: 400;
      //   }
      // }
    }
    @media screen and (min-width: 992px) {
      /deep/.el-textarea__inner {
        font-size: 20px;
      }
    }
    @media screen and (max-width: 991px) {
      /deep/.el-textarea__inner {
        font-size: 14px;
      }
    }
  }
}

.answer_radios_items {
  display: flex;
  flex-direction: row;
  align-items: center;
  // padding-left: 50px !important;
  position: relative;
  padding-top: 15px;
  padding-bottom: 15px;
}
.result_icon {
  width: auto;
  height: 24px;
  margin-right: 20px;
  position: absolute;
  left: 0;
  top: 31%;
}
/deep/.el-radio,
.el-radio__label {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.question_q_img {
  position: relative;
  width: 39px;
  height: 39px;
  text-align: center;
  line-height: 39px;
  margin-right: 16px;
  span {
    color: #fff;
    z-index: 1;
    position: relative;
    font-size: 20px;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
  }
}

@media screen and (min-width: 992px) {
  .question_item {
    .question_item_title {
      padding: 24px;
      .question_item_title_text {
        font-size: 24px;
        padding: 16px 12px;
      }
    }
    .question_item_answer {
      margin-left: 7%;
    }
  }
}
@media screen and (max-width: 991px) {
  .question_item {
    .question_item_title {
      padding-bottom: 14px;
      .question_item_title_text {
        font-size: 16px;
        padding: 10px;
      }
    }
  }
}
</style>